import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';

import { Home } from '../home';
import { EmployeeService } from './service/employee.service';
import { Employee } from './model//employee.model';

declare var $: any;

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.scss']
})
export class EmployeeComponent extends Home implements OnInit {

  @ViewChild('f') form;

  employees: any;
  get: Subscription;
  put: Subscription;
  post: Subscription;

  isLoading: boolean = false;
  
  constructor(private employeeService: EmployeeService, private router: Router, public employee: Employee) {
    super(router);
  }

  ngOnInit() {
    this.list();
  }

  list() {
    this.isLoading = true;
    this.get = this.employeeService.get()
      .subscribe(succ => {
        let ret: any = succ;

        if (ret.success) {
          this.employees = ret.items;
        }
        this.isLoading = false;
      },
        err => {
          console.log(err);
          this.isLoading = false;
          this.allowAcess(err.status);
        });
  }

  doEmployee(employee: Employee, valid: boolean) {

    if (!valid)
      return;

    if (!employee.id) {
      this.doCreated(employee);
    } else {
      this.doUpdated(employee);
    }
  }

  doUpdated(empl) {

    this.put = this.employeeService.put(empl.id, empl)
      .subscribe(succ => {
        let ret: any = succ;

        if (ret.success) {
          this.list();
          $('#myModal').modal('hide');
          this.openMessenge('Registro atualizado com sucesso.', 'success');
          this.clean();
        } else {
          this.openMessenge(ret.messege, 'danger');
        }
      },
        err => {
          console.log(err);
          this.openMessenge('Não foi possivel concluir a operação.', 'danger');
          this.allowAcess(err.status);
        });
  }

  doCreated(empl) {

    this.post = this.employeeService.post(empl)
      .subscribe(succ => {
        let ret: any = succ;

        if (ret.success) {
          this.list();
          $('#myModal').modal('hide');
          this.openMessenge('Registro cadastrado com sucesso.', 'success');
          this.clean();
        } else {
          this.openMessenge(ret.messege, 'danger');
        }
      },
        err => {
          console.log(err);
          this.openMessenge('Não foi possivel concluir a operação.', 'danger');
          this.allowAcess(err.status);
        });
  }

  loadRegister(id) {
    this.employee = this.employees.find(f => f.id == id);
    $('#myModal').modal('show');
  }

  clean() {
    this.employee = new Employee();
    this.form.resetForm();
  }

  ngOnDestroy() {
    if (this.get)
      this.get.unsubscribe();

    if (this.put)
      this.put.unsubscribe();

    if (this.post)
      this.post.unsubscribe();
  }
}